import image1 from '../images/image1.jpg';
import image2 from '../images/image2.jpg';
import image3 from '../images/image3.jpg';
import image5 from '../images/image5.jpg';
import image6 from '../images/image6.jpg';
import image7 from '../images/image7.jpg';
import image8 from '../images/image8.jpg';
import image9 from '../images/image9.jpg';
import image11 from '../images/image11.jpg';
import image12 from '../images/image12.jpg';
import image13 from '../images/image13.jpg';
import image14 from '../images/image14.jpg';
import image15 from '../images/image15.jpg';
import image16 from '../images/image16.jpg';
import image17 from '../images/image17.jpg';
import image18 from '../images/image18.jpg';
import image19 from '../images/image19.jpg';
import image20 from '../images/image20.jpg';
import image21 from '../images/image21.jpg';
import image22 from '../images/image22.jpg';

import atmosphere3 from '../images/atmosphere/image3.jpg';
import atmosphere4 from '../images/atmosphere/image4.jpg';
import atmosphere5 from '../images/atmosphere/image5.jpg';
import atmosphere6 from '../images/atmosphere/image6.jpg';
import atmosphere7 from '../images/atmosphere/image7.jpg';
import atmosphere8 from '../images/atmosphere/image8.jpg';
import atmosphere10 from '../images/atmosphere/image10.jpg';
import atmosphere11 from '../images/atmosphere/image11.jpg';
import atmosphere1 from '../images/atmosphere/image1.jpg';
import atmosphere2 from '../images/atmosphere/image2.jpg';
import atmosphere20 from '../images/atmosphere/image20.jpg';
import atmosphere12 from '../images/atmosphere/image12.jpg';
import atmosphere13 from '../images/atmosphere/image13.jpg';
import atmosphere14 from '../images/atmosphere/image14.jpg';
import atmosphere15 from '../images/atmosphere/image15.jpg';
import atmosphere16 from '../images/atmosphere/image16.jpg';
import atmosphere17 from '../images/atmosphere/image17.jpg';
import atmosphere18 from '../images/atmosphere/image18.jpg';
import atmosphere19 from '../images/atmosphere/image19.jpg';

import optimized1 from '../images/optimized/1.jpg';
import optimized2 from '../images/optimized/2.jpg';
import optimized3 from '../images/optimized/3.jpg';
import optimized4 from '../images/optimized/4.jpg';



export const translations = {
  ro: {
    nav: {
      home: 'Prezentare generală',
      menu: 'Meniu',
      reviews: 'Recenzii',
      about: 'Despre',
      contact: 'Contact'
    },
    hero: {
      title: 'SALOON & BEER',
      subtitle: 'pub-ul tău pentru o bere bună în Chișinău',
      description: 'Atmosferă plăcută, bere gustoasă și deservire la nivel.',
      rating: '4,6',
      reviews: '43 recenzii',
      type: 'Pub',
      address: 'Strada Cuza Vodă 10, Chișinău, Republica Moldova',
      hours: 'Închide curând · 23:00 · Deschide luni la 11:00',
      viewMenu: 'Vezi meniul',
      callNow: 'Sună acum'
    },
    menu: {
      title: 'Meniul nostru',
      subtitle: 'Descoperă selecția noastră de bere și gustări',
      beerDraft: 'Bere la draft',
      drinks: 'Băuturi',
      snacks: 'Gustări & Snack-uri',
      hookah: 'Narghilea'
    },
    reviews: {
      title: 'Ce spun clienții noștri',
      subtitle: 'Recenzii autentice de pe Google Maps',
      basedOn: 'Bazat pe',
      googleReviews: 'recenzii Google',
      viewAll: 'Vezi toate recenziile pe Google Maps'
    },
    about: {
      title: 'Despre noi',
      description: 'SALOON & BEER este locul unde te bucuri de bere bună, gustări savuroase și o atmosferă caldă în inima Chișinăului. Suntem cunoscuți pentru berea noastră Saloon, deservirea prietenoasă și ambianța perfectă pentru relaxare sau întâlniri cu prietenii.'
    },
    gallery: {
      title: 'Galeria noastră',
      // all: 'Toate',
      // food: 'Mâncăruri / băuturi',
      atmosphere: 'Atmosferă',
      videos: 'Videoclipuri'
    },
    contact: {
      title: 'Contact',
      address: 'Adresă',
      phone: 'Telefon',
      hours: 'Program',
      hoursDetails: 'L–D: 11:00 – 23:00',
      getDirections: 'Obține indicații',
      sendToPhone: 'Trimite pe telefon',
      formTitle: 'Trimite-ne un mesaj',
      name: 'Nume',
      email: 'Număr de telefon',
      message: 'Mesaj',
      send: 'Trimite'
    },
    footer: {
      rights: 'Toate drepturile rezervate'
    }
  },
  en: {
    nav: {
      home: 'Overview',
      menu: 'Menu',
      reviews: 'Reviews',
      about: 'About',
      contact: 'Contact'
    },
    hero: {
      title: 'SALOON & BEER',
      subtitle: 'Your pub for good beer in Chișinău',
      description: 'Pleasant atmosphere, tasty beer and top-level service.',
      rating: '4.6',
      reviews: '43 reviews',
      type: 'Pub',
      address: 'Cuza Vodă Street 10, Chișinău, Republic of Moldova',
      hours: 'Closing soon · 23:00 · Opens Monday at 11:00',
      viewMenu: 'View menu',
      callNow: 'Call now'
    },
    menu: {
      title: 'Our Menu',
      subtitle: 'Discover our selection of beer and snacks',
      beerDraft: 'Draft Beer',
      drinks: 'Drinks',
      snacks: 'Snacks & Appetizers',
      hookah: 'Hookah'
    },
    reviews: {
      title: 'What our customers say',
      subtitle: 'Authentic reviews from Google Maps',
      basedOn: 'Based on',
      googleReviews: 'Google reviews',
      viewAll: 'View all reviews on Google Maps'
    },
    about: {
      title: 'About us',
      description: 'SALOON & BEER is the place where you enjoy good beer, tasty snacks and a warm atmosphere in the heart of Chișinău. We are known for our Saloon beer, friendly service and the perfect ambiance for relaxation or meetings with friends.'
    },
    gallery: {
      title: 'Our Gallery',
      // all: 'All',
      // food: 'Food / drinks',
      atmosphere: 'Atmosphere',
      videos: 'Videos'
    },
    contact: {
      title: 'Contact',
      address: 'Address',
      phone: 'Phone',
      hours: 'Hours',
      hoursDetails: 'Mon–Sun: 11:00 – 23:00',
      getDirections: 'Get directions',
      sendToPhone: 'Send to phone',
      formTitle: 'Send us a message',
      name: 'Name',
      email: 'Phone number',
      message: 'Message',
      send: 'Send'
    },
    footer: {
      rights: 'All rights reserved'
    }
  }
};

export const menuItems = {
  beerDraft: [
    {
      id: 1,
      name: 'Berea Saloon',
      nameEn: 'Saloon Beer',
      description: 'Berea casei - nu e amară, foarte gustoasă și surprinzător de puternică',
      descriptionEn: 'House beer - not bitter, very tasty and surprisingly strong',
      price: '38 MDL',
      image: optimized4
    },
    {
      id: 2,
      name: 'Bere Blondă la Draft',
      nameEn: 'Blonde Draft Beer',
      description: 'Bere blondă proaspătă, perfect răcorită',
      descriptionEn: 'Fresh blonde beer, perfectly chilled',
      price: '30 - 90 MDL',
      image: optimized2
    },
    {
      id: 3,
      name: 'Bere Neagră la Draft',
      nameEn: 'Dark Draft Beer',
      description: 'Bere neagră cu gust bogat și aromă intensă',
      descriptionEn: 'Dark beer with rich taste and intense aroma',
      price: '58 MDL',
      image: optimized3
    }
  ],
  drinks: [
    { id: 4, name: 'Cocktailuri', nameEn: 'Cocktails', price: '55-75 MDL' },
    { id: 5, name: 'Băuturi răcoritoare', nameEn: 'Soft drinks', price: '25 MDL' },
    { id: 6, name: 'Cafea', nameEn: 'Coffee', price: '30 MDL' }
  ],
  snacks: [
    {
      id: 7,
      name: 'Pește Uscat',
      nameEn: 'Dried Fish',
      description: 'Pește sărat și uscat, perfect ca gustare pentru bere',
      descriptionEn: 'Salted and dried fish, perfect as a beer snack',
      image: image6
    },
    {
      id: 8,
      name: 'Vitrină cu Pește Afumat',
      nameEn: 'Smoked Fish Display',
      description: 'Selecție variată de pește afumat și fructe de mare',
      descriptionEn: 'A diverse selection of smoked fish and seafood',
      image: image7
    },
    {
      id: 9,
      name: 'Platou Gustări la Bere',
      nameEn: 'Beer Snacks Platter',
      description: 'Cârnaței, cartofi, murături și salată – perfect pentru grupuri',
      descriptionEn: 'Sausages, potatoes, pickles and salad – perfect for sharing',
      image: image8
    },
    {
      id: 10,
      name: 'Creveți Crocanți',
      nameEn: 'Crispy Shrimp',
      description: 'Creveți pane crocanți cu sos de usturoi',
      descriptionEn: 'Crispy breaded shrimp served with garlic sauce',
      image: image9
    },
    {
      id: 11,
      name: 'Mix de Pește Uscat și Afumat',
      nameEn: 'Dried & Smoked Fish Mix',
      description: 'Asortiment de pește uscat și afumat ideal pentru bere',
      descriptionEn: 'Assorted dried and smoked fish, ideal for beer',
      image: image11
    },
    {
      id: 12,
      name: 'Platou Tradițional',
      nameEn: 'Traditional Platter',
      description: 'Pâine neagră, castraveți murați, slănină și brânză',
      descriptionEn: 'Dark bread, pickles, cured pork fat and cheese',
      image: image13
    },
    {
      id: 13,
      name: 'Coaste la Grătar',
      nameEn: 'Grilled Ribs',
      description: 'Coaste fragede cu cartofi wedges și legume proaspete',
      descriptionEn: 'Tender grilled ribs with wedges and fresh vegetables',
      image: image1
    },
    {
      id: 14,
      name: 'Caracatiță Afumată',
      nameEn: 'Smoked Octopus',
      description: 'Caracatiță afumată lent, cu aromă intensă și textură delicată',
      descriptionEn: 'Slow-smoked octopus with rich aroma and delicate texture',
      image: image5
    },
    {
      id: 15,
      name: 'Raci Fierți',
      nameEn: 'Boiled Crayfish',
      description: 'Raci fierți cu mărar și lămâie – gustare perfectă la bere',
      descriptionEn: 'Boiled crayfish with dill and lemon – perfect beer snack',
      image: image14
    },
    {
      id: 16,
      name: 'Platou Asortat Cald',
      nameEn: 'Hot Mixed Platter',
      description: 'Carne la grătar, cârnaței, cartofi wedges, salată și sosuri',
      descriptionEn: 'Grilled meat, sausages, wedges, salad, and sauces',
      image: image15
    },
    {
      id: 17,
      name: 'Legume Grilate',
      nameEn: 'Grilled Vegetables',
      description: 'Vânătă, dovlecel, ardei și roșii cherry la grătar',
      descriptionEn: 'Grilled eggplant, zucchini, peppers, and cherry tomatoes',
      image: image17
    },
    {
      id: 18,
      name: 'Pește Afumat cu Bere',
      nameEn: 'Smoked Fish with Beer',
      description: 'Selecție de pește afumat servit cu un pahar de bere rece',
      descriptionEn: 'Selection of smoked fish served with a glass of cold beer',
      image: image18
    },
    {
      id: 19,
      name: 'Macrou Afumat',
      nameEn: 'Smoked Mackerel',
      description: 'Macrou afumat, condimentat ușor și gata de servit',
      descriptionEn: 'Smoked mackerel, lightly seasoned and ready to serve',
      image: image19
    }
    // {
    //   id: 20,
    //   name: 'Panini con Cotto',
    //   nameEn: 'Panini con Cotto',
    //   description: 'Chiflă pufoasă cu șuncă fiartă și cașcaval',
    //   descriptionEn: 'Soft bun with cooked ham and cheese',
    //   image: image20
    // },
    // {
    //   id: 21,
    //   name: 'Panini con Crudo',
    //   nameEn: 'Panini con Crudo',
    //   description: 'Chiflă cu prosciutto crud, roșie și salată',
    //   descriptionEn: 'Bun with prosciutto crudo, tomato, and lettuce',
    //   image: image21
    // },
    // {
    //   id: 22,
    //   name: 'Toast Cotto',
    //   nameEn: 'Cotto Toast',
    //   description: 'Toast cald cu șuncă fiartă și cașcaval topit',
    //   descriptionEn: 'Warm toast with cooked ham and melted cheese',
    //   image: image22
    // }
  ],
  hookah: [
    { id: 20, name: 'Narghilea clasică', nameEn: 'Classic Hookah', price: '250 MDL' },
    { id: 21, name: 'Narghilea premium', nameEn: 'Premium Hookah', price: '300 MDL' }
  ]
};

export const reviewsData = [
  {
    id: 1,
    name: 'Raveca Fralin',
    rating: 5,
    text: 'Un local super, cu deservire la un nivel înalt. Berea Saloon e foarte bună, nu prea amară… și dacă ești obosit, te duce ea 😁😁.',
    textEn: 'A great place with top-level service. Saloon Beer is very good, not too bitter... and if you\'re tired, it will get you 😁😁.'
  },
  {
    id: 2,
    name: 'Tatiana Ursu',
    rating: 5,
    text: 'Anturaj plăcut, atmosferă relaxantă și deservire la nivel. Revenim mereu pentru o halbă de bere și o narghilea!',
    textEn: 'Pleasant surroundings, relaxing atmosphere and top-level service. We always come back for a mug of beer and a hookah!'
  },
  {
    id: 3,
    name: 'Ruslan Tudorica',
    rating: 5,
    text: 'Un local foarte drag, cu atmosferă liniștită, bere bună și gustări excelente. Deservire pe cinste.',
    textEn: 'A very dear place with a quiet atmosphere, good beer and excellent snacks. Honest service.'
  }
];

export const galleryImages = [
  // {
  //   id: 1,
  //   url: 'https://images.unsplash.com/photo-1696062985889-de626efe0148',
  //   category: 'atmosphere',
  //   alt: 'Bar interior'
  // },
  // {
  //   id: 2,
  //   url: 'https://images.unsplash.com/photo-1584225065152-4a1454aa3d4e',
  //   category: 'food',
  //   alt: 'Draft beer'
  // },
  // {
  //   id: 3,
  //   url: 'https://images.unsplash.com/photo-1618183479302-1e0aa382c36b',
  //   category: 'food',
  //   alt: 'Beer glass'
  // },
  // {
  //   id: 4,
  //   url: 'https://images.unsplash.com/photo-1519351635902-7c60d09cb2ed',
  //   category: 'food',
  //   alt: 'Seafood platter'
  // },
  // {
  //   id: 2,
  //   url: 'https://images.unsplash.com/photo-1746003625469-9eee9bc8e509',
  //   category: 'atmosphere',
  //   alt: 'Bar atmosphere'
  // },
  // {
  //   id: 3,
  //   url: 'https://images.unsplash.com/photo-1763888834624-9021ada82ad8',
  //   category: 'atmosphere',
  //   alt: 'Bar interior with people'
  // },
  // {
  //   id: 4,
  //   url: 'https://images.unsplash.com/photo-1762047314688-b59b04b5f5de',
  //   category: 'atmosphere',
  //   alt: 'Busy bar'
  // },
  // {
  //   id: 5,
  //   url: 'https://images.unsplash.com/photo-1762237874410-17ddf6c782a1',
  //   category: 'atmosphere',
  //   alt: 'Social atmosphere'
  // }
    {
      id: 1,
      url: atmosphere3,
      category: 'atmosphere',
      alt: 'Christmas tree inside a cozy wooden bar'
    },
    {
      id: 2,
      url: atmosphere4,
      category: 'atmosphere',
      alt: 'TV displaying a fireplace inside a bar with warm lights'
    },
    {
      id: 3,
      url: atmosphere5,
      category: 'atmosphere',
      alt: 'Bar interior with round barrel tables and people sitting'
    },
    {
      id: 4,
      url: atmosphere6,
      category: 'atmosphere',
      alt: 'Two glasses of beer, one overflowing with foam'
    },
    {
      id: 5,
      url: atmosphere7,
      category: 'atmosphere',
      alt: 'Beer being poured into a Paulaner glass at the bar'
    },
    {
      id: 6,
      url: atmosphere8,
      category: 'atmosphere',
      alt: 'Wall decorations with cowboy-themed images and beer barrel ornaments'
    },
    {
      id: 7,
      url: atmosphere10,
      category: 'atmosphere',
      alt: 'Bright interior of saloon-style bar with wooden furniture'
    },
    {
      id: 8,
      url: atmosphere11,
      category: 'atmosphere',
      alt: 'Holiday-decorated bar interior with Christmas tree and lights'
    },
    {
      id: 9,
      url: atmosphere1,
      category: 'atmosphere',
      alt: 'Wooden exterior of Saloon bar with plants and signage'
    },
    {
      id: 10,
      url: atmosphere2,
      category: 'atmosphere',
      alt: 'Front entrance of Saloon bar with cars parked outside'
    },
    {
    id: 11,
    url: atmosphere20,
    category: 'atmosphere',
    alt: 'Outdoor seating area with wooden tables and people dining'
    },
    {
      id: 12,
      url: atmosphere12,
      category: 'atmosphere',
      alt: 'Wall of beer taps with labels and rustic decor'
    },
    {
      id: 13,
      url: atmosphere13,
      category: 'atmosphere',
      alt: 'Bar shelves filled with bottles of various spirits'
    },
    {
      id: 14,
      url: atmosphere14,
      category: 'atmosphere',
      alt: 'Wooden interior wall with framed pictures and barrel decorations'
    },
    {
      id: 15,
      url: atmosphere15,
      category: 'atmosphere',
      alt: 'Decorated wooden wall with themed frames and artwork'
    },
    {
      id: 16,
      url: atmosphere16,
      category: 'atmosphere',
      alt: 'Bar shelves illuminated with bottles of liquor'
    },
    {
      id: 17,
      url: atmosphere17,
      category: 'atmosphere',
      alt: 'Store shelves displaying beverages and snacks'
    },
    {
      id: 18,
      url: atmosphere18,
      category: 'atmosphere',
      alt: 'Exterior saloon building decorated with lights at dusk'
    },
    {
      id: 19,
      url: atmosphere19,
      category: 'atmosphere',
      alt: 'Front view of saloon building with illuminated sign in the evening'
    }

];

export const contactInfo = {
  address: 'Strada Cuza Vodă 10, Chișinău, Republica Moldova',
  addressEn: 'Cuza Vodă Street 10, Chișinău, Republic of Moldova',
  phone: '+373 780 15 880',
  plusCode: 'XVP7+2W Chișinău',
  plusCodeUrl: 'https://www.google.com/maps/search/XVP7%2B2W+Chișinău',
  mapUrl: 'https://maps.google.com/?q=Strada+Cuza+Voda+10+Chisinau'
};